import React from 'react';
import { sanitize } from 'helpers/utils/htmlSanitize';
import Image from 'frontastic/lib/image';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import usePreloadImages from 'helpers/hooks/usePreloadImages';

import { GenericSectionContent, Cta } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';
import styles from './index.module.css';

export default function SolisRendering({ content }: { content: GenericSectionContent }) {
  const { cards, title, description, ctas, cards_block_alignment, additional_css, additional_css_class_names } = content;

  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'SolisRendering');

  const card = cards?.[0];
  const image = card?.desktop_image;
  const isCardsLeft = cards_block_alignment === 'Left';

  usePreloadImages(image?.url ? [image.url] : []);

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div className={`relative  left-full  w-screen -translate-x-full lg:grid lg:grid-cols-12 pt-0 pb-24 lg:pb-40 2xl:pb-60 ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}>
        <div
          id="advice-section"
          className={`flex items-center  lg:col-span-12 lg:px-0 flex-col ${isCardsLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
        >
          <div className="relative  w-full xl:h-[32rem] md:h-[46rem] lg:flex-1 lg:flex-grow  h-[20rem] middleresolution:h-[37rem] 2xl:h-[45rem] ">
            {image?.url && (
              <Image
                priority
                loading='eager'
                src={image?.url}
                alt={image?.description ?? ''}
                fill
                style={{ objectFit: 'cover' }}
              />
            )}
          </div>
          <div className="flex-1 flex-grow lg:px-48 2xl:px-144">
            {title && (
              <Typography
                as="h1"
                className="relative pb-10 text-32 pt-10 font-medium leading-[3rem]"
              >
                {title}
              </Typography>
            )}
            {description && (
              <div
                className="image-container text-center px-24 text-16 md:text-18 xl:text-16 font-normal leading-6 text-[#333] lg:leading-8 2xl:text-20 [&>div>img]:mb-10 [&>p>img]:mb-10"
                dangerouslySetInnerHTML={{ __html: sanitize(description) }}
              />
            )}
            {ctas && ctas.length > 0 && (
              <div className="px-24">
                {ctas.map((cta: Cta, index: number) => (
                  <Link link={cta?.url} target={cta?.target} key={index}>
                    <Button className="mt-48 block m-auto w-full rounded-none border-2 border-[#2B2C39] bg-white px-18 py-16 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4] md:px-32 md:py-16 lg:w-fit">
                      <Typography as="span" className="text-16 font-semibold leading-5 xl:text-14 2xl:text-16 lg:leading-6 text-[#090909]">
                        {cta?.label}
                      </Typography>
                    </Button>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
